// Gateo RBAC del menú: qué ve el usuario y, con eso, si el portal tiene algo que mostrarle.
import type { Permission } from '@/api/types/permissions';
import type { AppShellNavGroup } from './AppShell';

export type PermissionCheck = (permission: Permission) => boolean;

/**
 * El menú que le corresponde al usuario: item sin `permission` siempre visible, y el grupo que se
 * queda sin items se cae con ellos.
 */
export function visibleNavGroups(
    nav: readonly AppShellNavGroup[],
    hasPermission: PermissionCheck,
): AppShellNavGroup[] {
    return nav
        .map((group) => ({
            ...group,
            items: group.items.filter((item) => {
                if (!item.permission) return true;
                const required =
                    typeof item.permission === 'string' ? [item.permission] : item.permission;
                return required.every((key) => hasPermission(key as Permission));
            }),
        }))
        .filter((group) => group.items.length > 0);
}

/**
 * Si el portal tiene al menos una pantalla para este usuario. Sin ninguna, entrar solo le da un
 * sidebar vacío sobre una pantalla que nunca carga.
 */
export function hasPortalAccess(
    nav: readonly AppShellNavGroup[],
    hasPermission: PermissionCheck,
): boolean {
    return visibleNavGroups(nav, hasPermission).length > 0;
}
